<template>
  <v-layout 
   pt-5
  mt-4
  justify-center>
   <v-flex xs6>
   <v-img
      :src="src"
      />
      </v-flex>
    <v-flex
      xs6  
    >
      <panel title="Page Not Found">
       <v-flex>
         Page Not Found.
         </v-flex>
      </panel>
    </v-flex>
  </v-layout>
</template>
<script>
import { mapState } from "vuex";
import { STRONG_COLOR } from "@/components/globals/consts";
import rmp_tagline from '@/assets/rmp_tagline.png'

export default {
  data() {
    return {
      strongColor: STRONG_COLOR,
      src: rmp_tagline,
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NotFound.vue